<template>
  <div class="home">
    <h1>Accident Plan Dangerzone</h1>
    <h2>Essential Links</h2>
    <ul>
      <li><router-link :to="{ name: 'Home' }">API Keys</router-link></li>
      <li><router-link :to="{ name: 'ReassignReports' }">Reassign Reports</router-link></li>
      <li><router-link :to="{ name: 'ReclaimEmail' }">Reclaim Email</router-link></li>
      <li>
        <router-link
          :to="{ name: 'ManageValueAddedResalers' }">
          Manage Value-added Resalers
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'HelloWorld',
  computed: {
    ...mapGetters({
      loggedIn: 'Login/loggedIn',
    }),
  },
  async mounted() {
    await this.hagridPromise('Login/checkLogin');
    if (!this.loggedIn) {
      this.$router.push('/login');
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/components/Menu.vue